const loadReducerModules = async (reducerLoaders = {}) => {
  const reducerEntries = Object.entries(reducerLoaders)
  const loadedReducers = await Promise.all(
    reducerEntries.map(async ([key, loadReducer]) => {
      if (typeof loadReducer !== 'function') {
        throw new TypeError(`Reducer loader "${key}" must be a function`)
      }

      const reducerModule = await loadReducer()
      const reducer = reducerModule?.default

      if (typeof reducer !== 'function') {
        throw new TypeError(
          `Reducer loader "${key}" must resolve to a default reducer function`,
        )
      }

      return [key, reducer]
    }),
  )

  return Object.fromEntries(loadedReducers)
}

export const loadWithReducers = async (loadComponent, reducerLoaders = {}) => {
  if (typeof loadComponent !== 'function') {
    throw new TypeError('Component loader must be a function')
  }

  if (
    !reducerLoaders ||
    typeof reducerLoaders !== 'object' ||
    Array.isArray(reducerLoaders)
  ) {
    throw new TypeError('Reducer loaders must be an object')
  }

  const hasReducers = Object.keys(reducerLoaders).length > 0
  const storePromise = hasReducers
    ? import('./configureStore')
    : Promise.resolve(null)

  const [componentModule, reducers, storeModule] = await Promise.all([
    loadComponent(),
    loadReducerModules(reducerLoaders),
    storePromise,
  ])

  if (!componentModule?.default) {
    throw new TypeError(
      'Component loader must resolve to a module with a default export',
    )
  }

  if (hasReducers) {
    storeModule.default.injectAsyncReducers(reducers)
  }

  return componentModule
}

export default loadWithReducers
